import DeviceCard from "./DeviceCard"
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import Lottie from "lottie-react";
import areYouSure from '../../../../assets/animations/areYouSure.json'
import { Button } from "primereact/button";
import { unlinkSigfoxAPI } from "../../../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

const TankSensorCard = ({tankSensor, pinObject, apiData, siteUUID, refreshDevices, showSuccess}) => {

    const sensorType = "Tank sensor"
    const sensorID = tankSensor.type.split(" ") //Likely changed this is based on it having the name before ID
    const [showConfirm, setShowConfirm] = useState(false)
    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);

    const unlink = async () => {
        const responseData = await unlinkSigfoxAPI(apiData, siteUUID, tankSensor.virtualInput, dispatch)
        if (responseData) {
            setShowConfirm(false)
            refreshDevices();
            showSuccess(true)
        }
    }

    return (
        <>
            <Dialog
                header="Are you sure?"
                visible={showConfirm}
                style={{ width: "40vw" }}
                onHide={() => setShowConfirm(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSure}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this sensor?`}</h3>
                    <br />
                    <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                    <br />
                    <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />
                </div>
            </Dialog>

            <DeviceCard
                header={`${sensorType}`}
                meta={[<Link to={`/Dashboard/Sensors/Sensor/${sensorID[1]}`}>{sensorID[1]}</Link>]}
                rightContent={
                <>
                    <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
                    {(role === "admin" || role === "TechSupport") && <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)} />}
                </>
                }
            />
        </>
        );
}

export default TankSensorCard;
